import { render, staticRenderFns } from "./News1920.vue?vue&type=template&id=ae890f64&scoped=true"
import script from "./News1920.vue?vue&type=script&lang=js"
export * from "./News1920.vue?vue&type=script&lang=js"
import style0 from "./News1920.vue?vue&type=style&index=0&id=ae890f64&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae890f64",
  null
  
)

export default component.exports